"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AccordionPanel_meta_1 = require("../AccordionPanel.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var Icon_1 = __importDefault(require("../../Icon/Icon"));

exports.default = InjectedStyledComponent_1.InjectedStyledComponent(Icon_1.default, AccordionPanel_meta_1.ACCORDION_PANEL_CATEGORY_KEY, AccordionPanel_meta_1.ACCORDION_PANEL_COMPONENT_KEY, ['toggle']);